// @flow

import React, { Component } from 'react';
import { ToastContainer, style } from 'react-toastify';
// import 'font-awesome-sass-loader';
import Header from '../components/Header';
import Loading from '../components/Loading';
import Routes from '../routes';
import styled from '../common/styled';

class App extends Component {
  componentDidMount() {
    style({
      colorSuccess: '#8ABC53',
      colorWarning: '#f1c40f',
      colorError: '#D66D7F',
      zIndex: 99999,
    });
  }

  render() {
    return (
      <div style={{ height: '100%' }} className="app">
        {/* <Header className="header" /> */}

        <section style={{ height: '100%' }} className="content">
          <Routes />
        </section>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
        />

        <Loading />
      </div>
    );
  }
}

export default App;
